import redirectInterceptor from '@/interceptors/redirect_interceptor'
import mapFoulingData from '@/domain/fouling/mapper'
import { _generateFoulingAverageChartOptions, _generateFoulingAverageSeries } from './utils/fouling_average_chart_options'
const getDefaultState = () => {
    return {
        foulingData: null,
        foulingDataLoading: true,
        foulingDataError: null,
    }
}

const state = getDefaultState()

const getters = {
    foulingAverageChartOptions: (state, getters, rootState) => {
        return _generateFoulingAverageChartOptions(rootState.cii.voyageDataForCiiHistory, state.foulingData)
    },
    foulingAverageSeriesData: (state, getters, rootState) => {
        return _generateFoulingAverageSeries(state.foulingData, rootState.cii.voyageDataForCiiHistory)
    }
}

const actions = {
    async fetchFoulingData({ commit }, vesselName) {
        commit('SET_FETCH_FOULING_DATA_LOADING')
        try {
            const basicUrl = localStorage.getItem('basicUrl')
            const response = await redirectInterceptor.get(
                `${basicUrl}/vesselperformance/vessel/${vesselName}/fouling`,
                {
                    headers: {
                        Authorization: localStorage.getItem('quad_token')
                    }
                }
            )
            const foulingData = mapFoulingData(response.data.data)
            commit('SET_FETCH_FOULING_DATA_SUCCESS', foulingData)
        } catch (error) {
            commit('SET_FETCH_FOULING_DATA_FAILED')
        }
    }
}

const mutations = {
    SET_FETCH_FOULING_DATA_SUCCESS(state, foulingData) {
        state.foulingData = foulingData
        state.foulingDataLoading = false
        state.foulingDataError = null
    },
    SET_FETCH_FOULING_DATA_LOADING(state) {
        state.foulingDataLoading = true
        state.foulingDataError = null
    },
    SET_FETCH_FOULING_DATA_FAILED(state) {
        state.foulingDataLoading = false
        state.foulingDataError = true
    }
}

export const foulingModule = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}